import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Table from "../../Table";
import {
  deleteCart,
  fetchAllCarts,
} from "../../../../redux/reducer/cartReducer";
import DetailsCartTable from "./DetailsCartTable";
import LoadingSpinner from "../../../animation/LoadingSpinner";
import BoxEmpty from "../../../boxDetials/boxEmpty";

const RequestedCart = () => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [editingProducts, setEditingProducts] = useState(null);
  const dispatch = useDispatch();
  const { allCarts, loading, error } = useSelector((state) => state.carts);
  const { t } = useTranslation();
  const [searchBox, setSearchBox] = useState("");

  const headers = [
    "ID",
    "Box. No",
    "Name",
    "Phone",
    "Status",
    "Area",
    // 'Notes',
    "Check Order",
    "Created At",
    "Fees Mar_Shp",
    "Tot_Cart",
    "Tot_Weight",
    "Actions",
    "Products",
  ];

  const refreshData = () => {
    dispatch(fetchAllCarts(["requested"]));
  };

  useEffect(() => {
    dispatch(fetchAllCarts(["requested"]));
  }, [dispatch]);

  const handleDelete = (cartId) => {
    if (window.confirm("Are you sure you want to delete this Cart?")) {
      dispatch(deleteCart(cartId))
        .unwrap()
        .then(() => {
          dispatch(fetchAllCarts(["requested"]));
        })
        .catch((error) => alert(error || "Failed to delete Cart."));
    }
  };

  const handleUpdate = () => {
    dispatch(fetchAllCarts(["requested"]));
  };
  const requestedCartsBefore = allCarts.filter(
    (cart) => cart.status === "requested"
  );
  const requestedCarts = allCarts
    .filter((cart) => cart.status === "requested")
    .filter((cart) =>
      cart.referenceCode?.toLowerCase().includes(searchBox.toLowerCase())
    );
  // console.log(pendingCarts)

  if (loading && requestedCartsBefore.length === 0) {
    return <LoadingSpinner />;
  }

  if (requestedCartsBefore.length === 0) {
    return <BoxEmpty title="Not Found Orders" />;
  }

  return (
    <Table
      title={t("Requested Orders")}
      headers={headers}
      data={requestedCarts}
      searchBox={searchBox}
      setSearchBox={setSearchBox}
      renderRow={(cart, index) => (
        <DetailsCartTable
          key={cart._id || index}
          index={index + 1}
          details={{
            id: cart._id,
            number: index + 1,
            boxNumber: cart.referenceCode,
            Name: cart.user?.name,
            phone: cart.user?.phone,
            countryCode: cart.user?.countryCode,
            status: cart.status,
            note: cart.notesAdmin,
            history: cart.createdAt,
            products: cart.products,
            DShippingFees: cart.totalDShippingFees,
            markaShipFees: cart.markaShipFees,
            paymentStatus: cart.paymentStatus,
            timeLeft: cart.timeLeft,
            totalCartPrice: cart.totalCartPrice,
            totalCartPriceBeforeFees: cart.totalCartPriceBeforeFees,
            area: cart.area,
            isCheck: cart.isCheck,
            totalWeight: cart.totalWeight,
            paymentPDF: cart.paymentPDF,
          }}
          isEditing={editingOrder === cart._id}
          setEditingOrder={setEditingOrder}
          isProducts={editingProducts === cart._id}
          setEditingProducts={setEditingProducts}
          onDelete={handleDelete}
          onUpdate={() => handleUpdate(cart._id)}
          refreshData={refreshData}
          loading={loading}
        />
      )}
    />
  );
};

export default RequestedCart;
